import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import { __rest as t } from "../../_virtual/_tslib.js";
import e from "dom-css";
import i, { cancel as s } from "raf";
import { Component as o, createElement as r, cloneElement as n } from "react";
import l from "../../utils/getInnerHeight.js";
import h from "../../utils/getInnerWidth.js";
import a from "../../utils/isString.js";
import { renderViewDefault as c, renderTrackHorizontalDefault as d, renderTrackVerticalDefault as u, renderThumbHorizontalDefault as g, renderThumbVerticalDefault as m } from "./defaultRenderElements.js";
import { disableSelectStyle as v, disableSelectStyleReset as p, containerStyleDefault as T, containerStyleAutoHeight as f, viewStyleDefault as H, viewStyleAutoHeight as w, viewStyleUniversalInitial as b, trackHorizontalStyleDefault as k, trackVerticalStyleDefault as S, thumbHorizontalStyleDefault as L, thumbVerticalStyleDefault as M } from "./styles.js";
var D = /*#__PURE__*/function (_o) {
  _inherits(D, _o);
  function D(t) {
    var _this;
    _classCallCheck(this, D);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(D).call(this, t)), _this.getScrollLeft = _this.getScrollLeft.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.getScrollTop = _this.getScrollTop.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.getScrollWidth = _this.getScrollWidth.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.getScrollHeight = _this.getScrollHeight.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.getClientWidth = _this.getClientWidth.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.getClientHeight = _this.getClientHeight.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.getValues = _this.getValues.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.scrollLeft = _this.scrollLeft.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.scrollTop = _this.scrollTop.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.scrollToLeft = _this.scrollToLeft.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.scrollToTop = _this.scrollToTop.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.scrollToRight = _this.scrollToRight.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.scrollToBottom = _this.scrollToBottom.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.handleWindowResize = _this.handleWindowResize.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.handleDrag = _this.handleDrag.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.handleDragEnd = _this.handleDragEnd.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.state = {
      didMountUniversal: !1
    };
    return _this;
  }
  _createClass(D, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addListeners(), this.update(), this.componentDidMountUniversal();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners(), s(this.requestFrame), clearTimeout(this.hideTracksTimeout), clearInterval(this.detectScrollingInterval);
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(t) {
      var e = this;
      var _this$props = this.props,
        i = _this$props.onScroll,
        s = _this$props.onScrollFrame;
      i && i(t), this.update(function (t) {
        var i = t.scrollLeft,
          o = t.scrollTop;
        e.viewScrollLeft = i, e.viewScrollTop = o, s && s(t);
      }), this.detectScrolling();
    }
  }, {
    key: "handleScrollStart",
    value: function handleScrollStart() {
      var t = this.props.onScrollStart;
      t && t(), this.handleScrollStartAutoHide();
    }
  }, {
    key: "handleScrollStartAutoHide",
    value: function handleScrollStartAutoHide() {
      var t = this.props.autoHide;
      t && this.showTracks();
    }
  }, {
    key: "handleScrollStop",
    value: function handleScrollStop() {
      var t = this.props.onScrollStop;
      t && t(), this.handleScrollStopAutoHide();
    }
  }, {
    key: "handleScrollStopAutoHide",
    value: function handleScrollStopAutoHide() {
      var t = this.props.autoHide;
      t && this.hideTracks();
    }
  }, {
    key: "handleWindowResize",
    value: function handleWindowResize() {
      this.update();
    }
  }, {
    key: "handleHorizontalTrackMouseDown",
    value: function handleHorizontalTrackMouseDown(t) {
      t.preventDefault();
      var e = t.target,
        i = t.clientX,
        _e$getBoundingClientR = e.getBoundingClientRect(),
        s = _e$getBoundingClientR.left,
        o = this.getThumbHorizontalWidth(),
        r = Math.abs(s - i) - o / 2;
      this.view.scrollLeft = this.getScrollLeftForOffset(r);
    }
  }, {
    key: "handleVerticalTrackMouseDown",
    value: function handleVerticalTrackMouseDown(t) {
      t.preventDefault(), t.stopImmediatePropagation();
      var e = t.target,
        i = t.clientY,
        _e$getBoundingClientR2 = e.getBoundingClientRect(),
        s = _e$getBoundingClientR2.top,
        o = this.getThumbVerticalHeight(),
        r = Math.abs(s - i) - o / 2;
      this.view.scrollTop = this.getScrollTopForOffset(r);
    }
  }, {
    key: "handleHorizontalThumbMouseDown",
    value: function handleHorizontalThumbMouseDown(t) {
      t.preventDefault(), this.handleDragStart(t);
      var e = t.target,
        i = t.clientX,
        s = e.offsetWidth,
        _e$getBoundingClientR3 = e.getBoundingClientRect(),
        o = _e$getBoundingClientR3.left;
      this.prevPageX = s - (i - o);
    }
  }, {
    key: "handleVerticalThumbMouseDown",
    value: function handleVerticalThumbMouseDown(t) {
      t.preventDefault(), this.handleDragStart(t);
      var e = t.target,
        i = t.clientY,
        s = e.offsetHeight,
        _e$getBoundingClientR4 = e.getBoundingClientRect(),
        o = _e$getBoundingClientR4.top;
      this.prevPageY = s - (i - o);
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart(t) {
      this.dragging = !0, t.stopImmediatePropagation(), this.setupDragging();
    }
  }, {
    key: "handleDrag",
    value: function handleDrag(t) {
      if (this.prevPageX) {
        var _e = t.clientX,
          _this$trackHorizontal = this.trackHorizontal.getBoundingClientRect(),
          _i = _this$trackHorizontal.left,
          _s = -_i + _e - (this.getThumbHorizontalWidth() - this.prevPageX);
        this.view.scrollLeft = this.getScrollLeftForOffset(_s);
      }
      if (this.prevPageY) {
        var _e2 = t.clientY,
          _this$trackVertical$g = this.trackVertical.getBoundingClientRect(),
          _i2 = _this$trackVertical$g.top,
          _s2 = -_i2 + _e2 - (this.getThumbVerticalHeight() - this.prevPageY);
        this.view.scrollTop = this.getScrollTopForOffset(_s2);
      }
      return !1;
    }
  }, {
    key: "handleDragEnd",
    value: function handleDragEnd() {
      this.dragging = !1, this.prevPageX = 0, this.prevPageY = 0, this.teardownDragging(), this.handleDragEndAutoHide();
    }
  }, {
    key: "handleDragEndAutoHide",
    value: function handleDragEndAutoHide() {
      var t = this.props.autoHide;
      t && this.hideTracks();
    }
  }, {
    key: "handleTrackMouseEnter",
    value: function handleTrackMouseEnter() {
      this.trackMouseOver = !0, this.handleTrackMouseEnterAutoHide();
    }
  }, {
    key: "handleTrackMouseEnterAutoHide",
    value: function handleTrackMouseEnterAutoHide() {
      var t = this.props.autoHide;
      t && this.showTracks();
    }
  }, {
    key: "handleTrackMouseLeave",
    value: function handleTrackMouseLeave() {
      this.trackMouseOver = !1, this.handleTrackMouseLeaveAutoHide();
    }
  }, {
    key: "handleTrackMouseLeaveAutoHide",
    value: function handleTrackMouseLeaveAutoHide() {
      var t = this.props.autoHide;
      t && this.hideTracks();
    }
  }, {
    key: "getScrollLeft",
    value: function getScrollLeft() {
      return this.view ? this.view.scrollLeft : 0;
    }
  }, {
    key: "getScrollTop",
    value: function getScrollTop() {
      return this.view ? this.view.scrollTop : 0;
    }
  }, {
    key: "getScrollWidth",
    value: function getScrollWidth() {
      return this.view ? this.view.scrollWidth : 0;
    }
  }, {
    key: "getScrollHeight",
    value: function getScrollHeight() {
      return this.view ? this.view.scrollHeight : 0;
    }
  }, {
    key: "getClientWidth",
    value: function getClientWidth() {
      return this.view ? this.view.clientWidth : 0;
    }
  }, {
    key: "getClientHeight",
    value: function getClientHeight() {
      return this.view ? this.view.clientHeight : 0;
    }
  }, {
    key: "getValues",
    value: function getValues() {
      var _ref = this.view || {},
        _ref$scrollLeft = _ref.scrollLeft,
        t = _ref$scrollLeft === void 0 ? 0 : _ref$scrollLeft,
        _ref$scrollTop = _ref.scrollTop,
        e = _ref$scrollTop === void 0 ? 0 : _ref$scrollTop,
        _ref$scrollWidth = _ref.scrollWidth,
        i = _ref$scrollWidth === void 0 ? 0 : _ref$scrollWidth,
        _ref$scrollHeight = _ref.scrollHeight,
        s = _ref$scrollHeight === void 0 ? 0 : _ref$scrollHeight,
        _ref$clientWidth = _ref.clientWidth,
        o = _ref$clientWidth === void 0 ? 0 : _ref$clientWidth,
        _ref$clientHeight = _ref.clientHeight,
        r = _ref$clientHeight === void 0 ? 0 : _ref$clientHeight;
      return {
        left: t / (i - o) || 0,
        top: e / (s - r) || 0,
        scrollLeft: t,
        scrollTop: e,
        scrollWidth: i,
        scrollHeight: s,
        clientWidth: o,
        clientHeight: r
      };
    }
  }, {
    key: "getThumbHorizontalWidth",
    value: function getThumbHorizontalWidth() {
      var _this$props2 = this.props,
        t = _this$props2.thumbSize,
        e = _this$props2.thumbMinSize,
        _this$view = this.view,
        i = _this$view.scrollWidth,
        s = _this$view.clientWidth,
        o = h(this.trackHorizontal),
        r = Math.ceil(s / i * o);
      return o === r ? 0 : t || Math.max(r, e);
    }
  }, {
    key: "getThumbVerticalHeight",
    value: function getThumbVerticalHeight() {
      var _this$props3 = this.props,
        t = _this$props3.thumbSize,
        e = _this$props3.thumbMinSize,
        _this$view2 = this.view,
        i = _this$view2.scrollHeight,
        s = _this$view2.clientHeight,
        o = l(this.trackVertical),
        r = Math.ceil(s / i * o);
      return o === r ? 0 : t || Math.max(r, e);
    }
  }, {
    key: "getScrollLeftForOffset",
    value: function getScrollLeftForOffset(t) {
      var _this$view3 = this.view,
        e = _this$view3.scrollWidth,
        i = _this$view3.clientWidth;
      return t / (h(this.trackHorizontal) - this.getThumbHorizontalWidth()) * (e - i);
    }
  }, {
    key: "getScrollTopForOffset",
    value: function getScrollTopForOffset(t) {
      var _this$view4 = this.view,
        e = _this$view4.scrollHeight,
        i = _this$view4.clientHeight;
      return t / (l(this.trackVertical) - this.getThumbVerticalHeight()) * (e - i);
    }
  }, {
    key: "setupDragging",
    value: function setupDragging() {
      e(document.body, v), "undefined" != typeof document && (document.addEventListener("mousemove", this.handleDrag), document.addEventListener("mouseup", this.handleDragEnd));
    }
  }, {
    key: "scrollLeft",
    value: function scrollLeft() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.view && (this.view.scrollLeft = t);
    }
  }, {
    key: "scrollTop",
    value: function scrollTop() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.view && (this.view.scrollTop = t);
    }
  }, {
    key: "scrollToLeft",
    value: function scrollToLeft() {
      this.view && (this.view.scrollLeft = 0);
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      this.view && (this.view.scrollTop = 0);
    }
  }, {
    key: "scrollToRight",
    value: function scrollToRight() {
      this.view && (this.view.scrollLeft = this.view.scrollWidth);
    }
  }, {
    key: "scrollToBottom",
    value: function scrollToBottom() {
      this.view && (this.view.scrollTop = this.view.scrollHeight);
    }
  }, {
    key: "addListeners",
    value: function addListeners() {
      if ("undefined" == typeof document || !this.view) return;
      var t = this.view,
        e = this.trackHorizontal,
        i = this.trackVertical,
        s = this.thumbHorizontal,
        o = this.thumbVertical;
      t.addEventListener("scroll", this.handleScroll), e.addEventListener("mouseenter", this.handleTrackMouseEnter), e.addEventListener("mouseleave", this.handleTrackMouseLeave), e.addEventListener("mousedown", this.handleHorizontalTrackMouseDown), i.addEventListener("mouseenter", this.handleTrackMouseEnter), i.addEventListener("mouseleave", this.handleTrackMouseLeave), i.addEventListener("mousedown", this.handleVerticalTrackMouseDown), s.addEventListener("mousedown", this.handleHorizontalThumbMouseDown), o.addEventListener("mousedown", this.handleVerticalThumbMouseDown), "undefined" != typeof window && window.addEventListener("resize", this.handleWindowResize);
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      if ("undefined" == typeof document || !this.view) return;
      var t = this.view,
        e = this.trackHorizontal,
        i = this.trackVertical,
        s = this.thumbHorizontal,
        o = this.thumbVertical;
      t.removeEventListener("scroll", this.handleScroll), e.removeEventListener("mouseenter", this.handleTrackMouseEnter), e.removeEventListener("mouseleave", this.handleTrackMouseLeave), e.removeEventListener("mousedown", this.handleHorizontalTrackMouseDown), i.removeEventListener("mouseenter", this.handleTrackMouseEnter), i.removeEventListener("mouseleave", this.handleTrackMouseLeave), i.removeEventListener("mousedown", this.handleVerticalTrackMouseDown), s.removeEventListener("mousedown", this.handleHorizontalThumbMouseDown), o.removeEventListener("mousedown", this.handleVerticalThumbMouseDown), "undefined" != typeof window && window.removeEventListener("resize", this.handleWindowResize), this.teardownDragging();
    }
  }, {
    key: "componentDidMountUniversal",
    value: function componentDidMountUniversal() {
      var t = this.props.universal;
      t && this.setState({
        didMountUniversal: !0
      });
    }
  }, {
    key: "teardownDragging",
    value: function teardownDragging() {
      e(document.body, p), "undefined" != typeof document && (document.removeEventListener("mousemove", this.handleDrag), document.removeEventListener("mouseup", this.handleDragEnd));
    }
  }, {
    key: "showTracks",
    value: function showTracks() {
      clearTimeout(this.hideTracksTimeout), e(this.trackHorizontal, {
        opacity: 1
      }), e(this.trackVertical, {
        opacity: 1
      });
    }
  }, {
    key: "hideTracks",
    value: function hideTracks() {
      var t = this;
      if (this.dragging) return;
      if (this.scrolling) return;
      if (this.trackMouseOver) return;
      var i = this.props.autoHideTimeout;
      clearTimeout(this.hideTracksTimeout), this.hideTracksTimeout = setTimeout(function () {
        e(t.trackHorizontal, {
          opacity: 0
        }), e(t.trackVertical, {
          opacity: 0
        });
      }, i);
    }
  }, {
    key: "detectScrolling",
    value: function detectScrolling() {
      var t = this;
      this.scrolling || (this.scrolling = !0, this.handleScrollStart(), this.detectScrollingInterval = setInterval(function () {
        t.lastViewScrollLeft === t.viewScrollLeft && t.lastViewScrollTop === t.viewScrollTop && (clearInterval(t.detectScrollingInterval), t.scrolling = !1, t.handleScrollStop()), t.lastViewScrollLeft = t.viewScrollLeft, t.lastViewScrollTop = t.viewScrollTop;
      }, 100));
    }
  }, {
    key: "raf",
    value: function raf(t) {
      var e = this;
      this.requestFrame && i.cancel(this.requestFrame), this.requestFrame = i(function () {
        e.requestFrame = void 0, t();
      });
    }
  }, {
    key: "update",
    value: function update(t) {
      var e = this;
      this.raf(function () {
        return e._update(t);
      });
    }
  }, {
    key: "_update",
    value: function _update(t) {
      var _this$props4 = this.props,
        i = _this$props4.onUpdate,
        s = _this$props4.hideTracksWhenNotNeeded,
        o = this.getValues(),
        r = o.scrollLeft,
        n = o.clientWidth,
        a = o.scrollWidth,
        c = h(this.trackHorizontal),
        d = this.getThumbHorizontalWidth(),
        u = {
          width: d,
          transform: "translateX(".concat(r / (a - n) * (c - d), "px)")
        },
        g = o.scrollTop,
        m = o.clientHeight,
        v = o.scrollHeight,
        p = l(this.trackVertical),
        T = this.getThumbVerticalHeight(),
        f = {
          height: T,
          transform: "translateY(".concat(g / (v - m) * (p - T), "px)")
        };
      if (s) {
        var _t = {
            visibility: a > n ? "visible" : "hidden"
          },
          _i3 = {
            visibility: v > m ? "visible" : "hidden"
          };
        e(this.trackHorizontal, _t), e(this.trackVertical, _i3);
      }
      e(this.thumbHorizontal, u), e(this.thumbVertical, f), i && i(o), "function" == typeof t && t(o);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      var i = 15,
        s = this.props,
        o = s.renderView,
        l = s.renderTrackHorizontal,
        h = s.renderTrackVertical,
        c = s.renderThumbHorizontal,
        d = s.renderThumbVertical,
        u = s.renderHitArea,
        g = s.tagName,
        m = s.autoHide,
        v = s.autoHideDuration,
        p = s.universal,
        D = s.autoHeight,
        z = s.autoHeightMin,
        V = s.autoHeightMax,
        E = s.style,
        W = s.children,
        O = s.autoHideTimeout,
        y = s.thumbMinSize,
        j = s.onUpdate,
        F = t(s, ["renderView", "renderTrackHorizontal", "renderTrackVertical", "renderThumbHorizontal", "renderThumbVertical", "renderHitArea", "tagName", "autoHide", "autoHideDuration", "universal", "autoHeight", "autoHeightMin", "autoHeightMax", "style", "children", "autoHideTimeout", "thumbMinSize", "onUpdate"]),
        R = this.state.didMountUniversal,
        x = Object.assign(Object.assign(Object.assign({}, T), D && Object.assign(Object.assign({}, f), {
          minHeight: z,
          maxHeight: V
        })), E),
        A = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, H), {
          marginRight: -15,
          marginBottom: -15
        }), D && Object.assign(Object.assign({}, w), {
          minHeight: a(z) ? "calc(".concat(z, " + 15px)") : z + i,
          maxHeight: a(V) ? "calc(".concat(V, " + 15px)") : V + i
        })), D && p && !R && {
          minHeight: z,
          maxHeight: V
        }), p && !R && b),
        C = {
          transition: "opacity ".concat(v, "ms"),
          opacity: 0
        },
        P = Object.assign(Object.assign(Object.assign({}, k), m && C), p && !R && {
          display: "none"
        }),
        B = Object.assign(Object.assign(Object.assign({}, S), m && C), p && !R && {
          display: "none"
        });
      return r(g, Object.assign(Object.assign({}, F), {
        style: x
      }), [n(null == o ? void 0 : o({
        style: A
      }), {
        key: "view",
        ref: function ref(t) {
          e.view = t;
        }
      }, W), n(null == l ? void 0 : l({
        style: P
      }), {
        key: "trackHorizontal",
        ref: function ref(t) {
          e.trackHorizontal = t;
        }
      }, n(null == c ? void 0 : c({
        style: L
      }), {
        ref: function ref(t) {
          e.thumbHorizontal = t;
        }
      })), n(null == u ? void 0 : u(), {
        key: "hitArea",
        onMouseDown: this.handleVerticalTrackMouseDown
      }, n(null == h ? void 0 : h({
        style: B
      }), {
        key: "trackVertical",
        ref: function ref(t) {
          e.trackVertical = t;
        }
      }, n(null == d ? void 0 : d({
        style: M
      }), {
        ref: function ref(t) {
          e.thumbVertical = t;
        }
      })))]);
    }
  }]);
  return D;
}(o);
D.defaultProps = {
  renderView: c,
  renderTrackHorizontal: d,
  renderTrackVertical: u,
  renderThumbHorizontal: g,
  renderThumbVertical: m,
  tagName: "div",
  thumbMinSize: 30,
  hideTracksWhenNotNeeded: !1,
  autoHide: !1,
  autoHideTimeout: 1e3,
  autoHideDuration: 200,
  autoHeight: !1,
  autoHeightMin: 0,
  autoHeightMax: 200,
  universal: !1
};
export { D as default };